import { render } from "./LocInput.vue?vue&type=template&id=2d85f274"
import script from "./LocInput.vue?vue&type=script&lang=js"
export * from "./LocInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__